import type { Channel } from '../../../../generated/graphql-manager';

export function getIdPathForChannel(channel: Channel, channels: Channel[], path = ''): string {
  const parentChannel = channels.find(({ id }) => id === channel.parentId);

  return parentChannel
    ? getIdPathForChannel(parentChannel, channels, channel.id + `${path ? '/' + path : ''}`)
    : channel.id + `${path ? '/' + path : ''}`;
}
